module.exports = __webpack_public_path__ + "static/media/cust-remittance.325af27c.svg";